<template>
  <div
    class="
      tw-flex
      cruise-slide
      tw-capitalize
      lg:tw-cursor-pointer
      sm:tw-p-1
      tw-pl-0
      lg:tw-p-0
    "
    @click="$emit('click')"
  >
    <img
      class="tw-w-16 lg:tw-w-9 tw-object-cover tw-shrink-0"
      :src="computedImage"
      alt="Banner image"
    />
    <div
      class="
        cruise-slide__data
        lg:tw-overflow-hidden
        tw-w-full tw-flex tw-items-center
      "
      :class="isActiveClass"
    >
      <div
        class="
          tw-flex-shrink-0 tw-text-xs
          cruise-slide__day
          tw-w-[4.5rem]
          sm:tw-w-16
          lg:tw-w-14 lg:tw-font-semibold lg:tw-text-xs
          tw-pl-3 tw-pr-1
        "
      >
        {{ computedDay }}
      </div>
      <div
        class="cruise-slide-info-data lg:p-1.5 lg:pl-0 lg:tw-overflow-hidden"
      >
        <div
          class="
            tw-font-semibold tw-text-xs
            sm:tw-text-xs
            lg:tw-text-xs
            tw-capitalize
            lg:tw-truncate
          "
        >
          {{ destinationName }}
        </div>
        <div class="tw-text-2xs tw-capitalize">{{ showDateOrTime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeConverter from "@/mixins/TimeConverter";
import TimeMixin from "@/stories/Components/CruiseItineraryDetail/Mixins/TimeMixin.js";

const dayjs = require("dayjs");

export default {
  name: "CruiseSlideCard",
  mixins: [TimeConverter, TimeMixin],
  props: {
    cardData: {
      type: Object,
      required: true,
    },
    isCardActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    showTime: {
      type: Boolean,
      required: false,
      default: false,
    },
    textLabels: {
      type: Object,
      required: true,
      default: () => {},
    },
    cruiseIndex: {
      type: Number,
      required: true,
      default: 0,
    },
  },

  computed: {
    isActiveClass() {
      return this.isCardActive ? "cruise-slide__data--active" : "";
    },
    isSeaDay() {
      return this.cardData?.IsSeaDay;
    },
    computedImage() {
      return (
        this.cardData.Images?.Desktop ||
        require("@/assets/images/sea-day-placeholder-desktop.jpg")
      );
    },
    showDateOrTime() {
      return this.showTime
        ? this.computedTime
        : `${this.cardData?.DayOfWeek.toLowerCase()} ${this.computedDate}`;
    },
    arrivalTimeExists() {
      return this.isValidTime(this.cardData?.ArrivalTime);
    },
    arrivalTimeString() {
      const arrivalTime = this.cardData?.ArrivalTime;
      return this.arrivalTimeExists
        ? `${
            this.textLabels?.cruiseCardPriceFromLabel
          } ${this.getNonMilitaryTime(arrivalTime, true)}`
        : "";
    },
    departureTimeExists() {
      return this.isValidTime(this.cardData?.DepartureTime);
    },
    departureTimeString() {
      const departureTime = this.cardData?.DepartureTime;
      return this.departureTimeExists
        ? `${this.textLabels?.cruiseItineraryToLabel} ${this.getNonMilitaryTime(
            departureTime,
            true
          )}`
        : "";
    },
    computedDate() {
      return dayjs(this.cardData?.Date).format(
        this.textLabels?.cruiseModalDateFormat || "DD MMM YYYY"
      );
    },
    computedTime() {
      return !this.isSeaDay
        ? `${this.arrivalTimeString} ${this.departureTimeString}`
        : "";
    },
    computedDay() {
      return `${this.textLabels?.cruiseItineraryDayLabel} ${
        this.cruiseIndex + 1
      }`;
    },
    destinationName() {
      return this.cardData?.Name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "CruiseSlideCard";
</style>
